export default {
  props: {
    transitionShow: {
      type: String,
      default: 'fade'
    },
    transitionHide: {
      type: String,
      default: 'fade'
    }
  },
  computed: {
    transitionProps: function transitionProps() {
      var show = "q-transition--".concat(this.transitionShow || this.defaultTransitionShow);
      var hide = "q-transition--".concat(this.transitionHide || this.defaultTransitionHide);
      return {
        appear: true,
        enterClass: "".concat(show, "-enter"),
        enterActiveClass: "".concat(show, "-enter-active"),
        enterToClass: "".concat(show, "-enter-to"),
        leaveClass: "".concat(hide, "-leave"),
        leaveActiveClass: "".concat(hide, "-leave-active"),
        leaveToClass: "".concat(hide, "-leave-to")
      };
    }
  }
};